import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.up('lg')]: {
      paddingLeft: theme.spacing(8),
      paddingRight: theme.spacing(8),
    },
  },
  button: {
    padding: `${theme.spacing(2)}px ${theme.spacing(5)}px`,
    textTransform: 'none',
    borderRadius: 0,
    [theme.breakpoints.down('sm')]: {
      width: '33%',
    },
  },
  perfectScrollbar: {
    width: 'inherit',
  },
  input: {
    display: 'none',
  },
  tabLeft: {
    borderRadius: '4px 0px 0px 0px',
  },
  tabRight: {
    borderRadius: '0px 4px 0px 0px',
  },
  tabRightAndLeft: {
    borderRadius: '4px 4px 0px 0px',
  },
  containerMenu: {
    display: 'flex',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  financialCard: {
    width: '100%',
    backgroundColor: theme.palette.custom.light,
  },
  financialBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    gridGap: theme.spacing(1),
    padding: theme.spacing(2),
  },
  financialBoxHighlight: {
    border: `1px dashed ${theme.palette.primary.main}`,
  },
  financialCardActionArea: {
    height: '100%',
  },
  link: {
    fontWeight: 500,
    cursor: 'pointer',
  },
}))

export default styles
